<h2 class="text-head">ใบเสร็จรับเงิน</h2>
<div class="customer-form">
    <p class="customer-leble">ลูกค้า:</p>
    <form class="example-form">
        <mat-form-field>
            <input type="text" matInput [formControl]="customerForm" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                (optionSelected)="selectCustomer($event.option.value)">
                <mat-option *ngFor="let option of customerList | async" [value]="option">
                    {{option.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </form>
</div>
<div class="text-right">
    <button mat-icon-button (click)="saveOrder()" id="printer_iconHP" printSectionId="bill_wholesale_HP_template"
        [useExistingCss]="true" ngxPrint>
        <mat-icon aria-hidden="false" aria-label="printer icon">printer</mat-icon>
    </button>
    <button mat-icon-button (click)="saveOrder()" [useExistingCss]="true" printSectionId="bill_wholesale_TM_template"
        ngxPrint>
        <img id="slip_printer_iconLM"
            src="https://cdn3.iconfinder.com/data/icons/printer-and-plotter-2/32/Thermal-POS-receipt-print-printer-512.png">
    </button>
    <button mat-icon-button (click)="openDialog()">
        <mat-icon aria-hidden="false" aria-label="printer icon">save</mat-icon>
    </button>
    <button mat-icon-button (click)="clearCart()">
        <mat-icon aria-hidden="false" aria-label="printer icon">remove_shopping_cart</mat-icon>
    </button>
</div>
<div class="total-price">
    <b>จำนวนทั้งหมด:</b> {{total_item}} ชิ้น
    <b>รวมสุทธิ:</b> {{total_price | number:'.2'}} บาท
</div>
<div class="example-container">
    <table mat-table [dataSource]="basket" class="mat-elevation-z8">
        <ng-container matColumnDef="no">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let index = index">
                <mat-checkbox>{{index+1}}</mat-checkbox>
            </td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>รายการ</th>
            <td mat-cell *matCellDef="let element">{{element.name}}</td>
        </ng-container>
        <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef class="td-conten-center">จำนวน</th>
            <td mat-cell *matCellDef="let element" class="td-conten-center">{{element.quantity}}</td>
        </ng-container>
        <ng-container matColumnDef="unit">
            <th mat-header-cell *matHeaderCellDef class="td-conten-center">หน่วย</th>
            <td mat-cell *matCellDef="let element" class="td-conten-center">{{element.unit_type}}</td>
        </ng-container>
        <ng-container matColumnDef="wholesale_price">
            <th mat-header-cell *matHeaderCellDef class="text-right">ราคา/หน่วย</th>
            <td mat-cell *matCellDef="let element" class="text-right">{{element.wholesale_price | number:'.2'}}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef class="text-right">รวมเงิน</th>
            <td mat-cell *matCellDef="let element" class="text-right">{{element.wholesale_amount | number:'.2'}}</td>
        </ng-container>
        <ng-container matColumnDef="choose">
            <th mat-header-cell *matHeaderCellDef class="text-right">ตัวเลือก</th>
            <td mat-cell *matCellDef="let element" class="text-right">
                <a>
                    <mat-icon aria-hidden="false" aria-label="delete icon" (click)="removeItem(element.product_id)">
                        delete
                    </mat-icon>
                </a>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>

<div id="bill_wholesale_HP_template">
    <div class="head-bill font-hp-bill">
        <H3>บริษัทโตโต้ชุปเปอร์มารท</H3>
        219 หมู่ 3 ต.หนองข่า อ.ปทุมราขวงศา จ.อำนาจเจริญ 37110 <br>
        เลขประจำตัวผู้เสียภาษี: 0375564000924 <br>
        โทร: 088-7634646
    </div>
    <div class="bill_cus_date">
        <h3 class="font-hp-bill">ลูกค้า: {{customer_name}}</h3>
        <h3 class="text-right-margin font-hp-bill">{{date | date:'d/M/yyyy'}}</h3>
    </div>
    <div>
        <table class="font-hp-bill" style="border-collapse: collapse">
            <tr>
                <th>#</th>
                <th>รายการ</th>
                <th>จำนวน</th>
                <th>หน่วย</th>
                <th>ราคา/หน่วย</th>
                <th>รวมเงิน</th>
            </tr>
            <tr *ngFor="let element of basket; let i = index" class="bill-tr">
                <td class="td-conten-center">{{i+1}}</td>
                <td>{{element.name}}</td>
                <td class="td-conten-center">{{element.quantity}}</td>
                <td class="td-conten-center">{{element.unit_type}}</td>
                <td class="td-conten-center">{{element.wholesale_price | number:'.2'}}</td>
                <td class="td-conten-center">{{element.wholesale_amount | number:'.2'}}</td>
            </tr>
        </table>
    </div>
    <div class="text-right-margin">
        รวมสุทธิ: <b>{{total_price | number:'.2'}} บาท</b><br>
        จำนวนทั้งหมด: <b>{{total_item}}</b> ชิ้น
    </div>

</div>
<div id="bill_wholesale_TM_template">
    <div class="head-bill font-tm-bill">
        <H3>บริษัทโตโต้ชุปเปอร์มารท</H3>
        219 หมู่ 3 ต.หนองข่า อ.ปทุมราขวงศา จ.อำนาจเจริญ 37110 <br>
        เลขประจำตัวผู้เสียภาษี: 0375564000924 <br>
        โทร: 088-7634646
    </div>
    <div class="bill_cus_date">
        <h3 class="font-tm-bill">ลูกค้า: {{customer_name}}</h3>
        <h3 class="date-bill font-tm-bill">{{date | date:'d/M/yyyy'}}</h3>
    </div>
    <div>
        <table class="font-tm-bill">
            <tr>
                <th class="text-left-bill">#</th>
                <th>รายการ</th>
                <th class="text-right-bill">จำนวน</th>
                <th class="text-right-bill">ราคา/หน่วย</th>
                <th class="text-right-bill">รวมเงิน</th>
            </tr>
            <tr *ngFor="let element of basket; let i = index">
                <td class="text-left-bill">{{i+1}}</td>
                <td>{{element.name}}</td>
                <td class="text-right-bill">{{element.quantity}}</td>
                <td class="text-right-bill">{{element.wholesale_price}}</td>
                <td class="text-right-bill">{{element.wholesale_amount | number:'.2'}}</td>
            </tr>
        </table>
    </div>
    <div class="text-right-bill">
        รวมสุทธิ: <b>{{total_price | number:'.2'}} บาท</b><br>
        จำนวนทั้งหมด: <b>{{total_item}} ชิ้น</b>
    </div>
</div>